import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledLi = styled.li`
    ${setFontVariant("body2", colorsPalettes.carbon[500])};
    line-height: 20px;

    & li {
        margin: 2px 0;
        &:before {
            top: 9px !important;
        }
    }
    & > ul {
        margin-bottom: 2px;
    }
`;

export const StyledLink = styled.a`
    ${setFontVariant("body2", colorsPalettes.blue[400])};
    text-decoration: underline;
`;

export const StyledTd = styled.td`
    padding: 12px 12px;
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
    text-align: left;
    overflow-wrap: break-word;
    ${setFontVariant("input2")}
    color: ${colorsPalettes.carbon[400]};
`;

export const StyledTh = styled(StyledTd)`
    ${setFontVariant("input2Bold")};
    color: ${colorsPalettes.carbon[500]};
    padding: 8px 12px;
`;

export const StyledTable = styled.table`
    width: 100%;
    margin-bottom: 20px;
    table-layout: fixed;
    background: ${colorsPalettes.carbon[0]};
    border-radius: 16px;
    border: 1px solid ${colorsPalettes.carbon[50]};
    padding: 16px;

    ${StyledTd}:last-child,
    ${StyledTh}:last-child {
        border-right: none;
    }

    tbody > tr:last-child > td {
        border-bottom: none;
    }
`;
